import React, { useState, useEffect } from "react";
import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  Icon,
  FormLabel,
  Select,
  Input,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import axios from "axios";
import PropTypes from "prop-types";
import {
  FaUser,
  FaBook,
  FaCalendarAlt,
  FaClipboardList,
  FaPen,
  FaCheck,
  FaAward,
  FaPlus,
  FaClipboard,
  FaComment,
} from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Modali = ({ isOpen, onClose }) => {
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [students, setStudents] = useState([]);
  const [exams, setExams] = useState([]);
  const [grades, setGrades] = useState([]);
  const [compliments, setCompliments] = useState([]);
  const [examDetails, setExamDetails] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [enteredMarks, setEnteredMarks] = useState("");
  const [selectedGrade, setSelectedGrade] = useState("");
  const [selectedCompliment, setSelectedCompliment] = useState("");
  const [description, setDescription] = useState("");
  const [examDate, setExamDate] = useState("");
  const [writtenMark, setWrittenMark] = useState("");
  const [internalMark, setInternalMark] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/class/class_master.php`)
      .then((response) => setClasses(response.data.data || []))
      .catch((error) => console.error("Error fetching classes:", error));
  }, []);

  useEffect(() => {
    if (selectedClass) {
      axios
        .post(`${BASE_URL}/admin/exam/list_all_exam_details.php`, {
          class_id: selectedClass,
        })
        .then((response) => {
          console.log("tee@@", response);
          setExamDetails(response.data.data || []);
        })
        .catch((error) => console.error("Error fetching exam details:", error));
    }
  }, [selectedClass]);

  useEffect(() => {
    if (selectedClass) {
      axios
        .get(`${BASE_URL}/admin/class/division.php`)
        .then((response) => setDivisions(response.data.data || []))
        .catch((error) => console.error("Error fetching divisions:", error));
    }
  }, [selectedClass]);

  useEffect(() => {
    if (selectedClass && selectedDivision) {
      axios
        .post(`${BASE_URL}/admin/exam/depending_student.php`, {
          class_id: selectedClass,
          division_id: selectedDivision,
        })
        .then((response) => {
          console.log("all stu@@",response)
          setStudents(response.data.data || [])})
        .catch((error) => console.error("Error fetching students:", error));
    }
  }, [selectedClass, selectedDivision]);

  useEffect(() => {
    if (selectedClass) {
      axios
        .post(`${BASE_URL}/staff/exam/depending_exam.php`, {
          class_id: selectedClass,
        })
        .then((response) => {
          console.log(" exam Response:", response); // Log the entire response object
          console.log("Response data:", response.data); // Log only the response data
          setExams(response.data.data || []);
        })
        .catch((error) => console.error("Error fetching exams:", error));
    }
  }, [selectedClass]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/admin/exam/compliment.php`)
      .then((response) => setCompliments(response.data.data || []))
      .catch((error) => console.error("Error fetching compliments:", error));

    axios
      .get(`${BASE_URL}/admin/exam/list_all_grade_master.php`)
      .then((response) => setGrades(response.data.data || []))
      .catch((error) => console.error("Error fetching grades:", error));
  }, []);

  useEffect(() => {
    const total = parseFloat(internalMark || 0) + parseFloat(writtenMark || 0);
    setTotalMarks(total);
  }, [internalMark, writtenMark]);

  const handleSubmit = () => {
    // console.log("usei@@:", sessionStorage.getItem("user_id"));
    const formData = {
      class_id: selectedClass,
      division_id: selectedDivision,
      student_id: selectedStudent,
      exam_id: selectedExam,
      internal_mark: internalMark,
      written_mark: writtenMark,
      marks: totalMarks,
      grade_master_id: selectedGrade,
      compliment_master_id: selectedCompliment,
      description,
      date_of_exam: examDate,
      pass: sessionStorage.getItem("user_id"),
      academic_year_id: sessionStorage.getItem("Academic"),
      school_id: sessionStorage.getItem("school_id"),
    };

    axios
      .post(`${BASE_URL}/admin/exam/create_exam_details.php`, formData)
      .then((response) => {
        console.log("Form submitted successfully:", response.data);
        onClose();
      })
      .catch((error) => console.error("Error submitting form:", error));
  };

  return (
    <Box borderRadius="md" mx="auto">
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            {" "}
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Add Marks
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
              <FormControl id="class" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaClipboardList} mr={1} color="teal.500" />
                  Class
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select class"
                  value={selectedClass}
                  onChange={(e) => setSelectedClass(e.target.value)}
                >
                  {classes.length > 0 ? (
                    classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class}
                      </option>
                    ))
                  ) : (
                    <option value="">No classes available</option>
                  )}
                </Select>
              </FormControl>
              <FormControl id="division" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaClipboardList} mr={1} color="teal.500" />
                  Division
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select division"
                  value={selectedDivision}
                  onChange={(e) => setSelectedDivision(e.target.value)}
                >
                  {divisions.length > 0 ? (
                    divisions.map((division) => (
                      <option key={division.id} value={division.id}>
                        {division.division}
                      </option>
                    ))
                  ) : (
                    <option value="">No divisions available</option>
                  )}
                </Select>
              </FormControl>
              <FormControl id="student" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaUser} mr={1} color="teal.500" />
                  Student
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select student"
                  value={selectedStudent}
                  onChange={(e) => setSelectedStudent(e.target.value)}
                >
                  {students.length > 0 ? (
                    students.map((student) => (
                      <option key={student.id} value={student.id}>
                        {student.name}
                      </option>
                    ))
                  ) : (
                    <option value="">No students available</option>
                  )}
                </Select>
              </FormControl>
              <FormControl id="exam" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaBook} mr={1} color="teal.500" />
                  Exam
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select exam"
                  value={selectedExam}
                  onChange={(e) => setSelectedExam(e.target.value)}
                >
                  {exams.length > 0 ? (
                    exams.map((exam) => (
                      <option key={exam.id} value={exam.id}>
                        {exam.subject} - {exam.category}
                      </option>
                    ))
                  ) : (
                    <option value="">No exams available</option>
                  )}
                </Select>
              </FormControl>
              <FormControl id="internalMark" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaPen} mr={1} color="teal.500" />
                  Internal Mark
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  type="number"
                  value={internalMark}
                  onChange={(e) => setInternalMark(e.target.value)}
                />
              </FormControl>
              <FormControl id="writtenMark" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaPen} mr={1} color="teal.500" />
                  Written Mark
                </FormLabel>
                <Input
                  type="number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={writtenMark}
                  onChange={(e) => setWrittenMark(e.target.value)}
                />
              </FormControl>
              <FormControl id="totalMarks" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaCheck} mr={1} color="teal.500" />
                  Total Marks
                </FormLabel>
                <Input
                  type="number"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={totalMarks}
                  isReadOnly
                />
              </FormControl>
              <FormControl id="grade" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaAward} mr={1} color="teal.500" />
                  Grade
                </FormLabel>
                <Select
                  placeholder="Select grade"
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={selectedGrade}
                  onChange={(e) => setSelectedGrade(e.target.value)}
                >
                  {grades.length > 0 ? (
                    grades.map((grade) => (
                      <option key={grade.id} value={grade.id}>
                        {grade.grade}
                      </option>
                    ))
                  ) : (
                    <option value="">No grades available</option>
                  )}
                </Select>
              </FormControl>
              <FormControl id="compliment" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaClipboard} mr={1} color="teal.500" />
                  Compliment
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  placeholder="Select compliment"
                  value={selectedCompliment}
                  onChange={(e) => setSelectedCompliment(e.target.value)}
                >
                  {compliments.length > 0 ? (
                    compliments.map((compliment) => (
                      <option key={compliment.id} value={compliment.id}>
                        {compliment.compliment}
                      </option>
                    ))
                  ) : (
                    <option value="">No compliments available</option>
                  )}
                </Select>
              </FormControl>
              <FormControl id="description" mb={4}>
                <FormLabel>
                  {" "}
                  <Icon as={FaComment} mr={1} color="teal.500" />
                  Description
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </FormControl>
            </SimpleGrid>
            {/* <FormControl id="examDate" mb={4}>
                            <FormLabel>Exam Date</FormLabel>
                            <Input type="date" value={examDate} onChange={(e) => setExamDate(e.target.value)} />
                        </FormControl> */}
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              mr={3}
              onClick={handleSubmit}
            >
              Save
            </Button>
            {/* <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

Modali.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Modali;
